import { ResourceManager } from "@/admin/ResourceManager";

const MIG = { key: "migration_status", label: "Migration Status", type: "select", options: [
  { value: "awaiting_verification", label: "Awaiting verification" },
  { value: "verified", label: "Verified" },
]};

export const CoachesManager = () => (
  <ResourceManager title="Coaches" subtitle="Add, edit, reorder and archive coaches." collection="coaches" imageKey="photo_url" primaryKey="name" secondaryKey="role"
    fields={[
      { key: "name", label: "Full Name", type: "text" },
      { key: "role", label: "Coaching Role", type: "text" },
      { key: "age_group", label: "Age Group", type: "text" },
      { key: "years_experience", label: "Years of Experience", type: "text" },
      { key: "qualifications", label: "Qualifications", type: "textarea", full: true },
      { key: "playing_experience", label: "Playing Experience", type: "textarea", full: true },
      { key: "biography", label: "Biography", type: "textarea", rows: 4, full: true },
      { key: "photo_url", label: "Profile Photo", type: "image" },
      MIG,
      { key: "active", label: "Active", type: "switch" },
      { key: "published", label: "Published", type: "switch" },
    ]} />
);

export const StaffManager = () => (
  <ResourceManager title="Staff" subtitle="Manage club management and staff members." collection="staff" imageKey="photo_url" primaryKey="name" secondaryKey="role"
    fields={[
      { key: "name", label: "Full Name", type: "text" },
      { key: "role", label: "Position / Title", type: "text" },
      { key: "description", label: "Description", type: "textarea", full: true },
      { key: "photo_url", label: "Photo", type: "image" },
      MIG,
      { key: "active", label: "Active", type: "switch" },
    ]} />
);

export const AgeGroupsManager = () => (
  <ResourceManager title="Age Groups" subtitle="Create, edit, reorder and deactivate age groups." collection="age_groups" imageKey="image_url" primaryKey="name" secondaryKey="description"
    fields={[
      { key: "name", label: "Age Group Name", type: "text" },
      { key: "coach_assignment", label: "Coach Assignment", type: "text" },
      { key: "description", label: "Description", type: "textarea", rows: 3, full: true },
      { key: "objectives", label: "Development Objectives", type: "list", full: true },
      { key: "skills", label: "Key Rugby Skills", type: "list", full: true },
      { key: "image_url", label: "Image", type: "image" },
      { key: "registration_status", label: "Registration Status", type: "text" },
      { key: "active", label: "Active", type: "switch" },
    ]} />
);

export const SponsorsManager = () => (
  <ResourceManager title="Sponsors" subtitle="Manage sponsors, logos, tiers and links." collection="sponsors" imageKey="logo_url" primaryKey="name" secondaryKey="tier"
    fields={[
      { key: "name", label: "Business Name", type: "text" },
      { key: "website", label: "Website URL", type: "text" },
      { key: "tier", label: "Sponsorship Tier", type: "text" },
      { key: "description", label: "Description", type: "textarea", full: true },
      { key: "logo_url", label: "Logo", type: "image" },
      MIG,
      { key: "active", label: "Active", type: "switch" },
    ]} />
);

export const TestimonialsManager = () => (
  <ResourceManager title="Testimonials" subtitle="Approve and manage parent testimonials." collection="testimonials" primaryKey="author" secondaryKey="location"
    fields={[
      { key: "author", label: "Author Name", type: "text" },
      { key: "location", label: "Location / Context", type: "text" },
      { key: "quote", label: "Testimonial", type: "textarea", rows: 4, full: true },
      { key: "approved", label: "Approved (show publicly)", type: "switch", default: false },
    ]} />
);
